module.exports = __webpack_public_path__ + "img/Household.bc5cb1f7.png";